import { render, staticRenderFns } from "./beziehungModal.vue?vue&type=template&id=842ef592"
import script from "./beziehungModal.vue?vue&type=script&lang=js"
export * from "./beziehungModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports